import { render, staticRenderFns } from "./SumLabelMakerCahaya.vue?vue&type=template&id=6081d2fe&scoped=true"
import script from "./SumLabelMakerCahaya.vue?vue&type=script&lang=js"
export * from "./SumLabelMakerCahaya.vue?vue&type=script&lang=js"
import style0 from "./SumLabelMakerCahaya.vue?vue&type=style&index=0&id=6081d2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081d2fe",
  null
  
)

export default component.exports